import React from 'react';
import PropTypes from 'prop-types';
import { useHistory } from 'react-router-dom';
import { useSelector } from 'react-redux';
import numberFormat from '../../utils/priceFormat';
import { DataLayerAddToCartEvent } from '../../utils/dataLayerUserEvent';
import PlanCategoryList from '../../utils/planCategoryList';
import plansStaticData from '../../API/data/plansData';
import DurationFormat from '../../utils/durationFormat';
import { getCurrentYear } from '../../utils/dateTimeFormat';

function DiscoverPlansCard(props) {
  const { plan, cartLineItemsFromStore, AddOneLineItemToCart } = props;
  const history = useHistory();

  const userStoreSession = useSelector(
    (state) => state.UserSessionReducer.userSessionStoreData
  );

  const planStaticDetails = plansStaticData.find(
    (item) =>
      item.planName.replace(/\s+/g, '-').toLowerCase() ===
        plan.name.replace(/\s+/g, '-').toLowerCase() ||
      item.planName1.replace(/\s+/g, '-').toLowerCase() ===
        plan.name.replace(/\s+/g, '-').toLowerCase() ||
      item.planName2.replace(/\s+/g, '-').toLowerCase() ===
        plan.name.replace(/\s+/g, '-').toLowerCase() ||
      item.planName3.replace(/\s+/g, '-').toLowerCase() ===
        plan.name.replace(/\s+/g, '-').toLowerCase()
  );

  const handleAddToCartEvent = () => {
    const categoryData = [];
    PlanCategoryList.map(
      (cat) => cat.planName === plan.name && categoryData.push(cat.categories)
    );
    const itemCategory =
      categoryData.length !== 0
        ? categoryData[0]
        : { item_category: plan.name };

    const planItem = [
      {
        item_id: plan.planUID,
        item_name: plan.name,
        affiliation: 'Discover Plan (Home)',
        coupon: '',
        discount: 0,
        index: 0,
        item_brand: 'Intelisys',
        item_list_id: plan.sellable === 'call' ? 1 : 2,
        item_list_name:
          plan.sellable === 'call' ? 'view_plan_Call' : 'view_plan_Analysis',
        item_variant: '',
        location_id: '',
        price: plan.price,
        quantity: 1,
        ...itemCategory,
      },
    ];
    let data;

    if (userStoreSession !== null) {
      data = {
        user_id: userStoreSession.userUID,
        currency: 'INR',
        value: plan.price,
        items: planItem,
      };
    } else {
      data = {
        currency: 'INR',
        value: plan.price,
        items: planItem,
      };
    }

    DataLayerAddToCartEvent(data);
  };

  const currentYear = getCurrentYear();

  return (
    <div
      className='p-3 rounded int-bg-light col-lg-3 col-11 m-2'
      style={{ boxShadow: '0px 1.6133px 3.2266px 0px rgba(0, 0, 0, 0.25)' }}
    >
      <h6 className='fw-semibold int-text-dark int-fs-20'>
        {plan.displayName}
      </h6>

      <div className='d-flex align-items-center justify-content-between'>
        <div>
          <p className='int-text-darkblue int-fs-12'>
            Returns Forecast {currentYear}
          </p>
          <p className='int-text-darkblue int-fs-25 fw-semibold'>
            {planStaticDetails && planStaticDetails.forecastROI
              ? planStaticDetails.forecastROI
              : plan && `${plan.monthlyReturn * 12}`}{' '}
            %
          </p>
        </div>
        <div>
          <p className='int-text-darkblue int-fs-12'>Total Returns</p>
          <p className='int-text-darkblue int-fs-25 fw-semibold'>
            {plan && plan.totalReturn} %
          </p>
        </div>
      </div>
      <div className='d-flex align-items-center mt-2'>
        <img
          className='img-fluid me-1'
          style={{ width: 35, height: 35 }}
          src='./images/money.webp'
          alt='stock market tips'
        />
        <div>
          <p className='int-fs-12 int-text-lightgray'>Returns</p>
          <p className='int-fs-16 int-text-green'>
            {planStaticDetails && planStaticDetails.returnType
              ? planStaticDetails.returnType
              : 'High'}{' '}
            Returns Plan
          </p>
        </div>
      </div>
      <div className='d-flex mt-2'>
        <div className='col-6 d-flex align-items-center'>
          <img
            className='img-fluid me-1'
            style={{ width: 35, height: 35 }}
            src='./images/volatility.webp'
            alt='stock market tips'
          />
          <div>
            <p className='int-fs-12 int-text-lightgray'>Volatility</p>
            <p className='int-fs-16 int-text-red'>
              {planStaticDetails && planStaticDetails.volatility
                ? planStaticDetails.volatility
                : 'High'}
            </p>
          </div>
        </div>
        <div className='col-6 d-flex align-items-center'>
          <img
            className='img-fluid me-1'
            style={{ width: 35, height: 35 }}
            src='./images/accuracy.webp'
            alt='stock market tips'
          />
          <div>
            <p className='int-fs-12 int-text-lightgray'>Accuracy</p>
            <p className='int-fs-16 int-text-darkblue'>
              {(planStaticDetails && `${planStaticDetails.accuracy} %`) ||
                '55 %'}
            </p>
          </div>
        </div>
      </div>

      <div className='d-flex mt-2'>
        <div className='col-6 d-flex align-items-center'>
          <img
            className='img-fluid me-1'
            style={{ width: 35, height: 35 }}
            src='./images/blueBell.webp'
            alt='stock market tips'
          />
          <div>
            <p className='int-fs-12 int-text-lightgray'>Signals/month</p>
            <p className='int-fs-16 int-text-darkblue'>
              {(planStaticDetails && planStaticDetails.callsPerMonth) ||
                '5 to 10 calls'}
            </p>
          </div>
        </div>
        <div className='col-6 d-flex align-items-center'>
          <img
            className='img-fluid me-1'
            style={{ width: 35, height: 35 }}
            src='./images/validity.webp'
            alt='stock market tips'
          />
          <div>
            <p className='int-fs-12 int-text-lightgray'>Validity</p>
            <p className='int-fs-16 int-text-darkblue'>
              {plan && DurationFormat(plan.duration)}
            </p>
          </div>
        </div>
      </div>
      <div className='mt-4 mb-2'>
        <span className='h5 fw-normal'>{numberFormat(plan.price)}/-</span>
      </div>

      <div className='d-flex align-items-center justify-content-between'>
        <button
          type='button'
          onClick={() =>
            history.push(
              `/plans/${plan.name.replace(/\s+/g, '-').toLowerCase()}`,
              plan.planUID
            )
          }
          aria-hidden
          className='w-50 btn btn-sm border-1 int-border int-text bg-transparent me-2'
        >
          view details
        </button>
        {cartLineItemsFromStore.filter(
          (item) => item.plan.planUID === plan.planUID
        ).length === 0 ? (
          <button
            type='button'
            onClick={() => {
              AddOneLineItemToCart(plan.planUID);
              handleAddToCartEvent();
            }}
            className='w-50 btn btn-sm int-bg text-white bg-transparent ms-2'
          >
            <i className='bi bi-cart-plus mx-2' />
            Add to Cart
          </button>
        ) : (
          <button
            type='button'
            onClick={() => history.push('/my-cart')}
            className='btn w-50 btn-sm btn-success text-white ms-2'
          >
            {' '}
            Go to cart
          </button>
        )}
      </div>
    </div>
  );
}

DiscoverPlansCard.propTypes = {
  plan: PropTypes.object,
  AddOneLineItemToCart: PropTypes.func.isRequired,
  cartLineItemsFromStore: PropTypes.array,
};

DiscoverPlansCard.defaultProps = {
  plan: [],
  cartLineItemsFromStore: [],
};

export default DiscoverPlansCard;
